import './Index.css';
import Menu from "./Menu";
import { Outlet } from 'react-router-dom';
import Header from '../Layout/Header';

function About() {



  return (
    <>
      123




    </>
  );
}

export default About;
